//-----------------------------|| LIST ||---------------------------------------------------------------
export const SET_USER_LIST = 'SET_USER_LIST';
export const CLEAR_USER_LIST = 'CLEAR_USER_LIST';
export const USER_LIST_PENDING = 'USER_LIST_PENDING';
export const USER_LIST_ERROR = 'USER_LIST_ERROR';
export const USER_LIST_ERROR_CLEAR = 'USER_LIST_ERROR_CLEAR';

//-----------------------------|| FILTER ||-------------------------------------------------------------
export const USER_FILTER_DIALOG_OPEN = 'USER_FILTER_DIALOG_OPEN';
export const USER_FILTER_DIALOG_CLOSE = 'USER_FILTER_DIALOG_CLOSE';
export const SET_USER_FILTER_DATA = 'SET_USER_FILTER_DATA';

//-----------------------------|| DETAILS ||------------------------------------------------------------
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const CLEAR_USER_DETAILS = 'CLEAR_USER_DETAILS';
export const USER_DETAILS_PENDING = 'USER_DETAILS_PENDING';
export const USER_DETAILS_ERROR = 'USER_DETAILS_ERROR';
export const USER_DETAILS_ERROR_CLEAR = 'USER_DETAILS_ERROR_CLEAR';

//-----------------------------|| RESET USER PASSWORD ||------------------------------------------------
export const USER_PASSWORD_RESET_PENDING = 'USER_PASSWORD_RESET_PENDING';
export const USER_PASSWORD_RESET_ERROR = 'USER_PASSWORD_RESET_ERROR';
export const USER_PASSWORD_RESET_ERROR_CLEAR = 'USER_PASSWORD_RESET_ERROR_CLEAR';
export const USER_PASSWORD_RESET_SUCCESS = 'USER_PASSWORD_RESET_SUCCESS';

//-----------------------------|| CREATE ||-------------------------------------------------------------
export const USER_CREATE_DIALOG_OPEN = 'USER_CREATE_DIALOG_OPEN';
export const USER_CREATE_DIALOG_CLOSE = 'USER_CREATE_DIALOG_CLOSE';
export const USER_CREATE_PENDING = 'USER_CREATE_PENDING';
export const USER_CREATE_ERROR = 'USER_CREATE_ERROR';
export const USER_CREATE_ERROR_CLEAR = 'USER_CREATE_ERROR_CLEAR';

//-----------------------------|| EDIT ||---------------------------------------------------------------
export const USER_EDIT_DIALOG_OPEN = 'USER_EDIT_DIALOG_OPEN';
export const USER_EDIT_DIALOG_CLOSE = 'USER_EDIT_DIALOG_CLOSE';
export const USER_EDIT_PENDING = 'USER_EDIT_PENDING';
export const USER_EDIT_ERROR = 'USER_EDIT_ERROR';
export const USER_EDIT_ERROR_CLEAR = 'USER_EDIT_ERROR_CLEAR';